import { useState } from "react";
import { SortOrder, ListTableSort } from "sprint-common-web";

export interface OrderOutputsSectionFilters {
    sortBy: string;
    sortOrder: SortOrder;
}

const defaultFilters: OrderOutputsSectionFilters = {
    sortBy: "updatedDate",
    sortOrder: "desc"
};

export const useOrderOutputsSectionFilters = () => {
    const [filters, setFilters] = useState<OrderOutputsSectionFilters>(defaultFilters);

    const setSort = ({ by: sortBy, order: sortOrder }: ListTableSort) => {
        setFilters((prevFilters: OrderOutputsSectionFilters) => ({
            ...prevFilters,
            sortBy,
            sortOrder,
            page: 1
        }));
    };

    const clearFilters = (): void => {
        setFilters(defaultFilters);
    };

    return {
        filters,
        setSort,
        clearFilters
    };
};
